import { render, staticRenderFns } from "./meetings-edit.vue?vue&type=template&id=585d6e1d&scoped=true&"
import script from "./meetings-edit.vue?vue&type=script&lang=js&"
export * from "./meetings-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d6e1d",
  null
  
)

export default component.exports